import { Loader } from '@googlemaps/js-api-loader'

export default {
  async install(vue) {
    const loader = new Loader({
      apiKey: 'AIzaSyDDpGdq0Cm4KSk0U7wZBGzcutjZZ4xmi7A',
      version: 'beta',
      libraries: ['marker'],
    })

    try {
      // TODO cater for google maps load error -> reject
      let gmapReadyResolveFunc
      vue.prototype.$gmapReady = new Promise((resolve) => {
        gmapReadyResolveFunc = resolve
      })
      const google = await loader.load()
      vue.prototype.$gmap = google
      gmapReadyResolveFunc(google)
    } catch (error) {
      console.error('plugins.gmaps.install.error', error)
    }
  },
}
